import React, {useCallback, useEffect, useState} from 'react';
import {NavLink} from "react-router-dom";
import {season} from "../../../models/season";
import {scrollTo} from "../../../service/ToolsService";
import {RaceList} from "../race/RaceList";
import {ApiQueryParam, ApiService, filter, sort} from "../../../service/ApiService";
import {race} from "../../../models/race";
import {defaultPagination} from "../../../types/PaginationType";
import {raceResultCollectionType, raceResultType} from "../../../types/Api/RaceResultType";
import {raceHydrator} from "../../../models/hydrator/raceHydrator";
import {Pagination} from "../Pagination";

type SeasonShowProps = {
  season: season,
}

export const SeasonShow = ({season}: SeasonShowProps) => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState([] as filter[]);
  const [sort, setSort] = useState({by: 'rideDate', direction: 'DESC'} as sort);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);
  const [races, setRaces] = useState([] as race[]);

  const findSeason = useCallback(() => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addFilter({
      op: 'eq',
      field: 'season_id',
      value: season.seasonId
    });

    filter.forEach((f: filter) => {
      apiFilters.addFilter(f)
    })

    apiFilters.addSort(sort);
    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);
    const result: Promise<raceResultCollectionType> = ApiService.get('/race', apiFilters) as Promise<raceResultCollectionType>;

    result
      .then((r: raceResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setRaces(r._embedded.races.map((race: raceResultType) => {
          return raceHydrator.hydrate(race);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setRaces([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [count, filter, page, season.seasonId, sort]);

  useEffect(() => {
    findSeason()
  }, [findSeason]);

  return (
    <>
      <div className="max-w600px pe-4 mb-4">
        <div className="col">
          <div className={`__admin_season_card card shadow-sm ${season.enabled ? 'border-success' : ''}`}>
            <div className="card-body">
              <h5 className="card-title">{season.label}</h5>

              <div className="mt-3 d-flex justify-content-between">
                <div className="card-text">
                  <strong>Actif :</strong> {season.enabled ? (<span className="badge bg-success">Oui</span>) : (<span className="badge bg-warning">Non</span>)}
                </div>

                <NavLink to={`/admin/season/edit/${season.seasonId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                  <i className="fa-solid fa-pencil me-1"/> modifier
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>

      <RaceList race={races} refresh={findSeason} loading={loading} sort={sort}
                filter={(filter: filter[]) => {
                  setFilter(filter)
                }}
                order={(s: string) => {
                  setSort({
                    by: s,
                    direction: (s !== sort?.by || sort.direction === 'DESC') ? 'ASC' : 'DESC'
                  })
                }} />
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}

      <div className="mt-3 d-flex justify-content-between">
        <NavLink to={`/admin/season`} onClick={scrollTo} className="btn btn-sm btn-info me-1">
          Retour aux saisons
        </NavLink>

        <NavLink to={`/admin/race/add/${season.seasonId}`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter une sortie
        </NavLink>
      </div>
    </>
  )
}
